<template>
    <!-- 订舱 -->
    <div  class="leave">
        <div class="title">订单留言</div>
        <div class="guestbook">
            <div>
                <div class="neir">
                    <el-avatar :src="avatar"></el-avatar>
                    <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入想要留言的内容"
                    class="word"
                    @focus="closeReplyBox"
                    v-model="newMessage">
                    </el-input>
                </div>
                <div class="fabiao">
                    <el-popover v-model="visibleEmoji" trigger="click">
                        <VEmojiPicker :showSearch="false" @select="selectEmoji" />
                        <i slot="reference" class="fa fa-smile-o"></i>
                    </el-popover>
                    <el-button  :disabled="!newMessage.trim()" @click="publishMessage">发表留言</el-button>
                </div>
            </div>
            <div class="yifabu" v-for="(item,index) in liuyanList" :key="index">
                <div class="liuyan">
                    <!-- 留言内容 -->
                    <div class="leftr">
                        <el-avatar :src="item.send.avatar" icon="el-icon-user-solid"></el-avatar>
                        <div class="info">
                            <div class="namen">
                                <span>{{item.send.nickname}}</span>
                                <span class="shijian">{{item.create_time}}</span>
                            </div>
                            <div class="hua">
                                {{item.message}}
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <!-- @click="zhanshi==index" -->
                        <el-button @click="reply(index)" type="text">回复</el-button>
                    </div>
                </div>

                <!-- 回复的留言 -->
                <div v-if="item.reply.nickname!=undefined" >
                    <div class="huifuliuyan">
                        <!-- 服务商789：有没有舱位吗？ -->
                        {{item.reply.nickname}}：{{item.reply.message}}
                    </div>
                </div>

                <!-- 回复留言  留言框 -->
                <div  v-if="replyIndex === index" class="huifu">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入想要留言的内容"
                        class="word"
                        v-model="replyMessage">
                        </el-input>
                    <div class="fabiao">
                        <el-button class="quxiao" @click="cancelReply">取消</el-button>
                        <el-button :disabled="!replyMessage.trim()" @click="submitReply(item.liuyan_id)">发表留言</el-button>
                        <el-popover v-model="visibleEmojiChild" trigger="click">
                            <VEmojiPicker :showSearch="false" @select="selectEmojiChild" />
                            <i slot="reference" class="fa fa-smile-o"></i>
                        </el-popover>
                    </div>
                </div>
            </div>

            <el-pagination
            v-show="total>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
            </el-pagination>
        </div>
    </div>
</template>
    
<script>
import { userliuyanLists,useraddLiuyan } from "@/api/api";
export default {
    components:{
    },
    props:{
        diaoyong:{
            type:Boolean,
            required:true
        }
    },
    data() {
        return {
            textarea:'', 
            // 回复框显示
            zhanshi: false,
            avatar:JSON.parse(localStorage.getItem('userInfo')).avatar,
            replyIndex: null, // 当前回复框的索引
            newMessage: "", // 新留言内容
            replyMessage: "", // 回复内容
            liuyanList:[], // 留言列表
            headers:{
                token: localStorage.getItem('token')
            },
            order_id: sessionStorage.getItem('itemId'),
            total:0,
            pageNo:1,
            pageSize:10,

            // 表情
            inputValue: "",
            blurPos: undefined,
            blurPosChild:undefined,

            visibleEmoji: false,
            visibleEmojiChild: false,
        }
    },
    methods: {
        reply(index){
            this.replyIndex = index;
            this.replyMessage = '' //清空回复框内容
        },
        // 取消回复
        cancelReply() {
            this.replyIndex = null;
            this.replyMessage = "";
        },
        // 关闭回复框
        closeReplyBox() {
            setTimeout(() => {
                this.replyIndex = null; // 确保回复框关闭
            }, 0);
        },
        // 发表留言
        async publishMessage(){
            if (!this.newMessage.trim()) return;
            try {
                const res = await useraddLiuyan({
                    order_id:this.$route.query.id,
                    liuyan_id:'',
                    message:this.newMessage.trim()
                },this.headers)
                if(res.code==1){
                //     this.liuyanList = res.data.lists
                    this.getLiuyanLists()
                    this.newMessage=''
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 回复留言
        async submitReply(index){
            if (!this.replyMessage.trim()) return;
            try {
                const res = await useraddLiuyan({
                    order_id:this.$route.query.id,
                    liuyan_id:index,
                    message:this.replyMessage.trim()
                },this.headers)
                if(res.code==1){
                //     this.liuyanList = res.data.lists
                    this.getLiuyanLists();
                    this.replyIndex = null;
                    this.replyMessage=''
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 获取留言列表
        async getLiuyanLists(){
            try {
                const res = await userliuyanLists({
                    order_id:this.$route.query.id,
                    page_no:this.pageNo,
                    page_size:this.pageSize
                },this.headers)
                if(res.code==1){
                    this.liuyanList = res.data.lists
                    this.total = res.data.count
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.getLiuyanLists()
        },
        handleCurrentChange(val) {
            this.pageNo = val
            this.getLiuyanLists()
        },
        selectEmoji(emoji) {
            if (this.newMessage === undefined) {
                this.newMessage = emoji.data;
            } else if (
                this.blurPos === undefined ||
                this.blurPos === this.newMessage.length
            ) {
                this.newMessage = `${this.newMessage}${emoji.data}`;
            } else {
                this.newMessage =
                this.newMessage.slice(0, this.blurPos) +
                emoji.data +
                this.newMessage.slice(this.blurPos);
            }
            this.visibleEmoji = false;
        },
        selectEmojiChild(emoji) {
            if (this.replyMessage === undefined) {
                this.replyMessage = emoji.data;
            } else if (
                this.blurPosChild === undefined ||
                this.blurPosChild === this.replyMessage.length
            ) {
                this.replyMessage = `${this.replyMessage}${emoji.data}`;
            } else {
                this.replyMessage =
                this.replyMessage.slice(0, this.blurPosChild) +
                emoji.data +
                this.replyMessage.slice(this.blurPosChild);
            }
            this.visibleEmojiChild = false;
        }
    },
    mounted(){
        if (this.diaoyong) {
            this.getLiuyanLists()
        }
    },
    watch: {
        diaoyong: {
            handler(newVal) {
                if(newVal){
                    console.log(111,'xind');
                    this.getLiuyanLists()
                }
            },
            deep: true
        }
    },
}
</script>
    
<style style lang="scss" scoped>

.leave{
    background: #fff;
    .title{
        margin-top: 24px;
        margin-bottom: 24px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .neir{
        display: flex;
        justify-content: space-between;
    }
    .el-avatar{
        width: 40px;
        height: 40px;
    }
    :deep(.el-textarea){
        width: 1076px;
        height: 160px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        textarea{
            width: 1076px;
            height: 160px;
            background: #F9F9F9;
            border: 0;
        }
    }

    .fabiao{
        text-align: right;
        margin-top: 20px;
        .el-button{
            width: 100px;
            height: 40px;
            background: #0073F5;
            border-radius: 8px 8px 8px 8px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            font-style: normal;
            text-transform: none;
            border: 0;
        }
    }

    .yifabu{
        
        margin-top: 34px;
        margin-bottom: 32px;

        .liuyan{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .leftr{
            display: flex;
            align-items: center;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
            .el-avatar{
                margin-right: 12px;
            }

            .shijian{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #999999;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }

        .right{
            .el-button{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #0073F5;
                font-style: normal;
                text-transform: none;
            }
        }

        .huifuliuyan{
            margin-top: 8px;
            margin-bottom: 8px;
            margin-left: 52px;
            height: 38px;
            background: #F9F9F9;
            padding: 0 12px;
            display: inline-block;
            line-height: 38px;
            font-size: 12px;
            color: #999999;
        }
    }

    .huifu{
        width: 420px;
        margin-left: 52px;
        margin-top: 8px;
        :deep(.el-textarea){
            width: 420px;
            height: 160px;
            background: #F9F9F9;
            border-radius: 8px 8px 8px 8px;
            textarea{
                width: 420px;
                height: 160px;
                background: #F9F9F9;
                border: 0;
            }
        }

        .quxiao{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            background: none;
            border: 0;
        }
    }
}

.el-pagination{
    text-align: right;
    margin-top: 32px;
}

.fa-smile-o{
    font-size: 24px;
    margin-left: 12px;
    margin-right: 12px;
}
</style>